import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { networkService } from "../../../config/axios";
import LaserlinkSessHeading from "../SessionComponents/LaserlinkSessHeading";
import SessionActiveTab from "../SessionComponents/SessionActiveTitle";
import SessionData from "../SessionComponents/SessionData";
import SessionHeading from "../SessionComponents/SessionHeading";
import SessionTable from "../SessionComponents/SessionTabls";
import StatPdfViewer from "../SessionComponents/StatPdfViewer";
import styles from "./Session.module.css";
import LoadingScreen from "../../../Elements/LoadingScreen/LoadingScreen";
import "../../../../../../app/assets/stylesheets/icomoon.css.scss";

const Session = () => {
  const [sessionData, setSessionData] = useState([]);
  const [showWithTags, setShowWithTags] = useState(false);
  const [selectedPage, setSelectedPage] = useState({ id: 1, index: 0 });
  const [sessionIndex, setSessionIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false)
  const { hash } = useLocation();
  const {
    tl,
    doc,
    pdfFile: { thumbs_details },
  } = window.objInit;
  const pdfFile = window.objInit.pdfFile;
  const data = doc || tl;
  const initialLoadRef = useRef(false);
  const isFetchingRef = useRef(false);
  
  // Global pending request tracker for component-level deduplication
  if (typeof window !== 'undefined' && !window.__STATS_SESSION_PENDING_REQUEST__) {
    window.__STATS_SESSION_PENDING_REQUEST__ = null;
  }

  const updateReceiverInfo = async () => {
    // Prevent duplicate concurrent calls
    if (isFetchingRef.current) {
      return;
    }
    
    const receiver = hash.replace("#/session/", "") || "";
    const token = data?.token || data?.group_id;
    const type = tl ? "tl" : "doc";
    const url = `/statistics/receivers?receiver=${receiver}&token=${token}&type=${type}`;
    
    // Create a stable payload key for deduplication
    const payloadKey = JSON.stringify({ receiver, token, type });
    
    // Clear pending request if payload differs
    if (typeof window !== 'undefined' && window.__STATS_SESSION_PENDING_REQUEST__) {
      const existing = window.__STATS_SESSION_PENDING_REQUEST__;
      if (existing.payloadKey !== payloadKey) {
        window.__STATS_SESSION_PENDING_REQUEST__ = null;
      }
    }
    
    // Check if there's already a pending request with the same payload (component-level deduplication)
    const pendingRequest = window.__STATS_SESSION_PENDING_REQUEST__;
    if (pendingRequest && pendingRequest.payloadKey === payloadKey && pendingRequest.promise) {
      // Update loading state and wait for the existing promise
      setIsLoading(true);
      
      try {
        const response = await pendingRequest.promise;
        if (response.data?.length > 0) {
          setIsLoading(false);
          setSessionData(response.data);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("error ", error);
      }
      
      return; // Exit early, we're using the shared promise
    }
    
    // No pending request, create a new one
    setIsLoading(true);
    isFetchingRef.current = true;
    
    // Create the request promise and store it globally for deduplication
    const requestPromise = networkService(url, "GET");
    
    // Store the pending request globally so other calls can reuse it
    if (typeof window !== 'undefined') {
      window.__STATS_SESSION_PENDING_REQUEST__ = {
        payloadKey: payloadKey,
        promise: requestPromise,
        timestamp: Date.now()
      };
    }
    
    try {
      const response = await requestPromise;
      if (response.data?.length > 0) {
        setIsLoading(false);
        setSessionData(response.data);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("error ", error);
    } finally {
      isFetchingRef.current = false;
      
      // Clear the pending request after a short delay to allow StrictMode remounts to complete
      setTimeout(() => {
        if (typeof window !== 'undefined' && window.__STATS_SESSION_PENDING_REQUEST__) {
          const pending = window.__STATS_SESSION_PENDING_REQUEST__;
          const timeSinceRequest = Date.now() - pending.timestamp;
          // Only clear if it's been more than 100ms (enough time for StrictMode remounts)
          if (timeSinceRequest > 100) {
            window.__STATS_SESSION_PENDING_REQUEST__ = null;
          }
        }
      }, 150);
    }
  };

  useEffect(() => {
    // Prevent duplicate initial load calls within the same mount
    // Allow StrictMode remounts to proceed - component-level deduplication will handle them
    if (initialLoadRef.current) {
      return;
    }
    initialLoadRef.current = true;
    updateReceiverInfo();
  }, []);

  return (
    <>
      {isLoading ? <LoadingScreen /> :
        <>
          {sessionData?.map((viewDt, viewInd) => {
            const currentSession = viewDt?.sessions?.[sessionIndex];
            const effectiveThumbsDetails = currentSession?.historical_thumbs_details || thumbs_details;
            const effectivePdfFile = currentSession?.historical_pdf_url
              ? { ...pdfFile, file: { ...pdfFile.file, url: currentSession.historical_pdf_url } }
              : pdfFile;

            return (
            <div key={`${viewInd}-${viewDt?.optin_session?.id}`}>
              <Row>
                {/* <Col md={8}>
                  <Row className="my-2"> */}
                    <Col md={6}>
                      <LaserlinkSessHeading
                        viewDt={viewDt}
                        sessionIndex={sessionIndex}
                      />
                    </Col>
                    <Col md={6}>
                      <SessionData
                        viewDt={viewDt}
                        thumbs_details={thumbs_details}
                      />
                    </Col>
                  {/* </Row>
                </Col> */}
              </Row>
              <Row className="mt-5">
                <Col md={8} sm={8} >
                  <SessionActiveTab
                    data={viewDt}
                    sessionIndex={sessionIndex}
                    setSessionIndex={setSessionIndex}
                  />
                  {viewDt?.sessions?.filter((session, idx) => {
                    return idx == sessionIndex;
                  })?.map(
                    (session, idx) =>
                      <div key={idx}>
                          <div className={styles.statsViewerContainer}>
                            <SessionHeading
                              session={session}
                              thumbs_details={effectiveThumbsDetails}
                              data={viewDt}
                            />
                            <div className="d-flex my-2">
                              <span
                                onClick={() => setShowWithTags((prev) => true)}
                                className="text-link-success text-white tag-primary mx-1"
                              >
                                Show pages without tags
                              </span>
                              <span
                                onClick={() => setShowWithTags((prev) => false)}
                                className="text-link-success text-white tag-primary mx-1"
                              >
                                Show all
                              </span>
                            </div>

                            <SessionTable
                              sessionIndex={idx}
                              setSelectedPage={setSelectedPage}
                              session={session}
                              selectedFilter={showWithTags ? 'not_tagged' : 'all'}
                              sessions={viewDt.sessions}
                              selectedPage={selectedPage}
                              thumbs_details={effectiveThumbsDetails}
                              receiver={{
                                name: viewDt?.name,
                                email: viewDt?.email
                              }}
                            />
                          </div>
                        </div>
                  )}
                </Col>
                <Col md={4} sm={4}>
                  <StatPdfViewer
                    pdfFile={effectivePdfFile}
                    doc={doc}
                    tl={tl}
                    selectedPage={selectedPage}
                    viewerData={sessionData}
                  />
                </Col>
              </Row>
            </div>
            );
          })}
        </>
      }
    </>
  );
};
export default Session;
